const storage = {
    not_configured: 'ارائه‌دهنده ذخیره‌سازی پیکربندی نشده است.',
    missing_parameter: 'پارامتر {{parameter}} برای ارائه‌دهنده ذخیره‌سازی وجود ندارد.',
    upload_error: 'آپلود فایل به ارائه‌دهنده ذخیره‌سازی ناموفق بود.',
    download_error: 'Failed to download file from the storage provider.',
};
export default Object.freeze(storage);
